import { Box, ListItemText, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { mergeParams } from "../utils/url";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { MouseEventHandler, useMemo } from "react";
import { useIntegrations } from "../hooks/query/useIntegrations";
import { Integration } from "../types";

export const IntegrationPicker: React.FC<{
  value: string;
  onChange: (v: Integration) => void;
  onlySetupIntegrations?: boolean;
}> = ({value, onChange, onlySetupIntegrations = true}) => {
  const {data: integrations = [] } = useIntegrations();
  const selectableIntegrations = useMemo(() => {
    if (!onlySetupIntegrations) {
      return integrations;
    }
    return integrations.filter((integration) => integration.auth?.ready === true);
  }, [integrations, onlySetupIntegrations]);

  const {pathname} = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const onNew: MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`${pathname}?${mergeParams(searchParams, new URLSearchParams({dialog: "new-integration"})).toString()}`);
  }

  const handleChange = (event: SelectChangeEvent<typeof value>) => {
    const v = event.target.value;
    if(v && v.length > 0) {
        const integration = selectableIntegrations.find(i => i.id === v);
        if(integration) {
            onChange(integration);
        }else {
            console.error("Integration not found with id", v);
        }
    }
  };

  const selectedValue = selectableIntegrations.some((integration) => integration.id === value)
    ? value
    : "";

  return <Select
            size="small"
            value={selectedValue}
            onChange={handleChange}
            displayEmpty
        >
            <MenuItem key="new-integration">
                <ListItemText onClick={onNew}>
                    <Box display="flex" gap={1} alignItems="center">
                    <FontAwesomeIcon icon={faPlus} />
                        New
                    </Box>
                </ListItemText>
            </MenuItem>

            {selectableIntegrations?.map((ap) => (
                <MenuItem value={ap.id} key={ap.id}>
                    {ap.name}
                </MenuItem>
            ))}
        </Select>
}
